import Request from './request';

async function fetch(data, noLoading) {
    return Request('get', "api/report-downloads", data, noLoading);
}

async function read(id) {
    return Request('post', "api/report-downloads/web-read/" + id);
}

async function saveMemo(data) {
    return Request('post', "api/report-downloads/save-memo", data);
}

export default {
    fetch,
    read,
    saveMemo,
};